import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import cx from "classnames";

import { logAnalyticsEvent } from "../utils/analytics";

import { Layout } from "../components/Layout";

function Press({ data }) {
  const heroScreenshot = data.prismicHomepage.data.body[0].primary.app_preview;
  const missionScreenshot = data.prismicPressPage.data.mission_image;

  // Track Press kit downloads
  const trackDownload = () => {
    logAnalyticsEvent("select_content", {
      content_type: "file_download",
      content_id: "press_kit_zip",
      file_type: "zip",
      file_name: "media-kit_SchengenSimple.zip",
      location: "press_page",
    });
  };

  return (
    <Layout
      metaTitle="Press"
      metaDescription="For media enquiries, please contact press@schengensimple.com"
    >
      <section className="bg-gradient-to-br from-gradients-teal via-gradients-teal-mid to-powder-blue px-4 md:px-10 py-10 md:py-28">
        <div className="container flex flex-col md:flex-row">
          <div className="w-100 md:w-9/12 flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-white mb-4 md:mb-8">
              Press and media enquiries
            </h2>

            <h3 className="text-base md:text-2xl text-white mb-4 md:mb-10 md:mr-10">
              Get in touch at{" "}
              <a href="mailto:press@schengensimple.com">
                press@schengensimple.com
              </a>
            </h3>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/schengen-simple.appspot.com/o/PressKit%2FSchengen%20Simple%20-%20Press%20Kit.zip?alt=media&token=7d8e6a4c-fca9-4a86-a00c-430d310809f0"
              download="media-kit_SchengenSimple.zip"
              target="_blank"
              rel="noreferrer"
              onClick={() => trackDownload()}
              className="py-2 px-4 lg:py-3 lg:px-8 rounded border-solid border-2 border-white text-teal hover:text-white bg-white hover:bg-teal-alpha-30 uppercase text-base md:text-xl lg:text-2xl font-medium no-underline self-start cursor-pointer block"
            >
              Download the press kit
            </a>
          </div>
        </div>
      </section>
      <section className="container antialiased py-10 md:py-16 lg:py-20">
        <div className="xl:w-10/12 mx-auto">
          <h2 className="text-center text-3xl lg:text-4xl xl:text-5xl font-medium mb-10 md:mb-16 lg:mb-24">
            About Schengen Simple
          </h2>
          <div className="flex flex-col md:flex-row gap-10">
            <div className="md:w-2/3 flex flex-col gap-4">
              <PrismicRichText
                field={data.prismicPressPage.data.missionStatement.richText}
              />
            </div>
            <GatsbyImage
              image={heroScreenshot.gatsbyImageData}
              alt={heroScreenshot.alt}
              className="md:w-1/3 mx-auto"
              objectFit="contain"
            />
          </div>
        </div>
      </section>
      <div className="h-6 md:h-10 bg-teal-alpha-30 mb-6 md:mb-10"></div>
    </Layout>
  );
}

export const query = graphql`
  query PressPage {
    prismicPressPage {
      data {
        missionStatement: mission_statement {
          richText
        }
        mission_image {
          gatsbyImageData(width: 400, placeholder: BLURRED)
        }
      }
    }
    prismicHomepage {
      data {
        body {
          ... on PrismicHomepageDataBodyHero {
            primary {
              app_preview {
                gatsbyImageData(width: 350, placeholder: BLURRED)
                alt
              }
            }
          }
        }
      }
    }
  }
`;

export default Press;
